(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
	(function () {
	  function initHeroExternalVideos(root) {
		if (!root || root.dataset.heroExternalVideosReady === 'true') return;
		root.dataset.heroExternalVideosReady = 'true';

		function youtubeCommand(iframe, func, args) {
		  if (!iframe.contentWindow) return;
		  iframe.contentWindow.postMessage(JSON.stringify({
			event: 'command',
			func: func,
			args: args || []
		  }), '*');
		}

		function vimeoCommand(iframe, method, value) {
		  if (!iframe.contentWindow) return;
		  var message = { method: method };
		  if (typeof value !== 'undefined') message.value = value;
		  iframe.contentWindow.postMessage(JSON.stringify(message), '*');
		}

		function sendPlayerCommand(iframe, command, value) {
		  var provider = iframe.dataset.provider;
		  if (provider === 'youtube') {
			youtubeCommand(iframe, command, value === undefined ? [] : [value]);
		  } else if (provider === 'vimeo') {
			vimeoCommand(iframe, command, value);
		  }
		}

		root.querySelectorAll('[data-hero-external-video]').forEach(function (wrapper) {
		  var iframe = wrapper.querySelector('[data-hero-video-iframe]');
		  if (!iframe) return;

		  /*
		   * YouTube/Vimeo iframes do not support object-fit: cover themselves.
		   * Make the iframe a 16:9 player that is large enough to cover the
		   * complete wrapper, centre it, and let overflow:hidden crop the excess.
		   */
		  function fitExternalVideo() {
			var width = wrapper.clientWidth;
			var height = wrapper.clientHeight;
			if (!width || !height) return;

			var videoRatio = 16 / 9;
			var containerRatio = width / height;
			var videoWidth;
			var videoHeight;

			/*
			 * If the hero is wider than 16:9, match its width and make the
			 * player taller. The top/bottom overflow is then cropped.
			 */
			if (containerRatio > videoRatio) {
			  videoWidth = width;
			  videoHeight = width / videoRatio;
			} else {
			  /*
			   * If the hero is taller/narrower than 16:9, match its height and
			   * make the player wider. The left/right overflow is cropped.
			   */
			  videoHeight = height;
			  videoWidth = height * videoRatio;
			}

			iframe.style.setProperty('width', videoWidth + 'px', 'important');
			iframe.style.setProperty('height', videoHeight + 'px', 'important');
			iframe.style.setProperty('left', '50%', 'important');
			iframe.style.setProperty('top', '50%', 'important');
			iframe.style.setProperty('transform', 'translate(-50%, -50%)', 'important');
		  }

		  fitExternalVideo();

		  /*
		   * ResizeObserver catches hero-height changes that do not necessarily
		   * fire a window resize event (responsive/theme-editor layout changes).
		   */
		  var resizeObserver = new ResizeObserver(function () {
			fitExternalVideo();
		  });
		  resizeObserver.observe(wrapper);

		  window.addEventListener('resize', fitExternalVideo);

		  var provider = iframe.dataset.provider;
		  var soundButton = wrapper.querySelector('[data-hero-video-sound]');
		  var playButton = wrapper.querySelector('[data-hero-video-play]');
		  var muted = wrapper.dataset.heroMuted !== 'false';
		  var autoplay = wrapper.dataset.heroAutoplay !== 'false';

		  function updateSoundButton(soundOn) {
			if (!soundButton) return;
			soundButton.setAttribute('aria-pressed', soundOn ? 'true' : 'false');
			soundButton.setAttribute('aria-label', soundOn ? 'Turn sound off' : 'Turn sound on');
			var label = soundButton.querySelector('[data-sound-label]');
			var icon = soundButton.querySelector('[data-sound-icon]');
			if (label) label.textContent = soundOn ? 'Sound off' : 'Sound on';
			if (icon) icon.textContent = soundOn ? '🔇' : '🔊';
		  }

		  function setSound(soundOn) {
			if (provider === 'youtube') {
			  youtubeCommand(iframe, soundOn ? 'unMute' : 'mute');
			  youtubeCommand(iframe, 'playVideo');
			} else if (provider === 'vimeo') {
			  vimeoCommand(iframe, 'setVolume', soundOn ? 1 : 0);
			  vimeoCommand(iframe, 'play');
			}
			updateSoundButton(soundOn);
		  }

		  soundButton?.addEventListener('click', function (event) {
			event.preventDefault();
			event.stopPropagation();
			var isOn = soundButton.getAttribute('aria-pressed') === 'true';
			setSound(!isOn);
		  });

		  playButton?.addEventListener('click', function (event) {
			event.preventDefault();
			event.stopPropagation();
			sendPlayerCommand(iframe, 'playVideo');
			if (provider === 'vimeo') vimeoCommand(iframe, 'play');
			playButton.hidden = true;
		  });

		  iframe.addEventListener('load', function () {
			fitExternalVideo();
			if (provider === 'youtube') {
			  youtubeCommand(iframe, 'setPlaybackQuality', ['hd1080']);
			  if (muted) youtubeCommand(iframe, 'mute');
			  if (autoplay) youtubeCommand(iframe, 'playVideo');
			} else if (provider === 'vimeo') {
			  if (muted) vimeoCommand(iframe, 'setVolume', 0);
			  if (autoplay) vimeoCommand(iframe, 'play');
			}
			updateSoundButton(!muted);
		  });
		});
	  }

	  function boot() {
		document.querySelectorAll('[id^="Hero-"]').forEach(initHeroExternalVideos);
	  }

	  if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', boot, { once: true });
	  } else {
		boot();
	  }

	  document.addEventListener('shopify:section:load', function (event) {
		var root = event.target && event.target.querySelector
		  ? event.target.querySelector('[id^="Hero-"]')
		  : null;
		if (root) initHeroExternalVideos(root);
	  });
	})();
	
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
